import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken, { getSessionToken } from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'
import { textAnalysisTemplate } from 'containers/TextAnalysis/Template'

const { collectionIndex, toolName, userType } = textAnalysisTemplate

interface SentimentParams {
  source_id?: string
  owner_id?: string
}

const axios = (extraParams: Record<string, any> = {}) => {
  const token =
    process.env.NODE_ENV === 'production' ? getSessionToken() : getToken()

  return AxiosInitializer({
    token,
    transformResConfig: false,
    paramsSerializerConfig: true,
    ...extraParams,
    tool: toolName,
  })
}

const sentimentAPI = {
  sentimentSummary: ({ source_id, owner_id }: SentimentParams) => {
    const params = {
      source_id,
      key_name: 'owner.id',
      key_value: owner_id,
    }
    return axios().get('sentiment/aggregate', { params })
  },
  backfillSentiment: ({ source_id, owner_id }: SentimentParams) => {
    const body = { scope: { type: 'owner', value: owner_id } }
    const params = {
      source_id,
      attributes: { 'owner.id': owner_id },
      collection_index: collectionIndex,
      user_type: userType,
    }
    return axios().patch('sentiment/backfill', body, { params })
  },
}

const taSentimentAPI = {
  sentimentSummary: (params = {}) =>
    apiWrapper({
      endPoint: sentimentAPI.sentimentSummary,
      params,
    }),
  backfillSentiment: (params = {}) =>
    apiWrapper({
      endPoint: sentimentAPI.backfillSentiment,
      params,
    }),
}

export { sentimentAPI }
export default taSentimentAPI
